import { AxiosResponse } from "axios";

import { TeamMembersModel, TeamMembersModelResponse } from "../../types";

const convertUsersResponse = ({ data }: AxiosResponse<TeamMembersModelResponse>): TeamMembersModel[] => data.users;

export default { convertUsersResponse };
